import {
    getMptWeeks, editMptWeek, editMptCard,
    editMptDestination, postMptDestination,
    postMptDestinationD0, postMptDestinationD6,
    postMptWeek, postMptCard, publishMpt, validateTransfertMPT,
    startCalculationMPT, checkRunningCalculation,
} from '../../entities/mpt/weeks'

export const scope = 'MPT_WEEKS';

export function getWeeks() {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(getMptWeeks(scope));
    };
}

export function editWeek(payload, weekId) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(editMptWeek(payload, weekId, scope));
    };
}

export function editCard(payload, weekId, cardId) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(editMptCard(payload, weekId, cardId, scope));
    };
}

export function editDestination(payload, weekId, cardId, dest ) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(editMptDestination(payload, weekId, cardId, dest, scope));
    };
}

export function postDestination(payload, weekId, cardId ) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(postMptDestination(payload, weekId, cardId, scope));
    };
}

export function postDestinationD0(payload, weekId, cardId ) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(postMptDestinationD0(payload, weekId, cardId, scope));
    };
}

export function postDestinationD6(payload, weekId, cardId ) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(postMptDestinationD6(payload, weekId, cardId, scope));
    };
}

export function postWeek(payload) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(postMptWeek(payload, scope));
    };
}

export function postCard(payload, weekId) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(postMptCard(payload, weekId, scope));
    };
}

export function publish() {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(publishMpt());
    };
}

export function validateTransert(payload, weekId, cardId) {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(validateTransfertMPT(payload, weekId, cardId, scope));
    };
}

export function startCalculation() {
    return (dispatch, getState) => {
        const { weeks } = getState().app.mpt;

        if (!weeks.info.isFetching)
            dispatch(startCalculationMPT());
    };
}

export function checkRunning() {
    return (dispatch, getState) => {
        // const { weeks } = getState().app.mpt;
        //
        // if (!weeks.info.isFetching)
            dispatch(checkRunningCalculation(scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/mpt/weeks.js